import { useReveal } from "../hooks/useReveal";
import { ArrowUpRight } from "lucide-react";

export default function CTA() {
  const ref = useReveal();
  return (
    <section
      data-testid="cta-section"
      className="relative py-24 lg:py-32 bg-[#4A6076] text-white overflow-hidden"
    >
      <div className="absolute inset-0 opacity-10">
        <svg viewBox="0 0 800 400" className="w-full h-full">
          <defs>
            <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse">
              <path d="M60 0H0V60" fill="none" stroke="white" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div ref={ref} className="reveal relative max-w-[90rem] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <p className="overline text-white/70 mb-6 flex items-center gap-3">
            Ready When You Are
          </p>
          <h2
            data-testid="cta-headline"
            className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight"
          >
            Let&rsquo;s create surfaces that leave a
            <em className="italic"> lasting impression</em>.
          </h2>
        </div>
        <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-4 lg:items-end">
          <a
            href="#contact"
            data-testid="cta-consultation-btn"
            className="btn-ghost-light w-full sm:w-auto justify-center bg-white text-[#1C1917] border-white hover:bg-transparent hover:text-white"
          >
            Request Consultation <ArrowUpRight size={16} strokeWidth={1.5} />
          </a>
          <a
            href="#services"
            data-testid="cta-portfolio-btn"
            className="btn-ghost-light w-full sm:w-auto justify-center"
          >
            Explore Services
          </a>
        </div>
      </div>
    </section>
  );
}
